import { render, staticRenderFns } from "./RailsSectionForm.vue?vue&type=template&id=21748351&scoped=true&"
import script from "./RailsSectionForm.vue?vue&type=script&lang=js&"
export * from "./RailsSectionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21748351",
  null
  
)

/* custom blocks */
import block0 from "./RailsSectionForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports